<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import AlternativesViewDependenciesList from "@Alternatives/AlternativesViews/Components/AlternativesViewDependenciesList.vue";
    import { AlternativesViewDependenciesDialogViewModel } from "@Alternatives/AlternativesViews/Components/AlternativesViewDependenciesDialog";

    @Component({
        components: { AlternativesViewDependenciesList },
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class AlternativesViewDependenciesDialog extends Vue
    {
        get vm(): AlternativesViewDependenciesDialogViewModel { return this.$props.viewModel as AlternativesViewDependenciesDialogViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get initialized(): boolean { return this.vm?.initialized ?? false; }
        get name(): string { return this.vm.name; }
        get dependenciesCount(): number | null { return this.vm.dependenciesCount }
        get reports() { return this.vm.reports; }
        get lists() { return this.vm.lists; }
        get estimationsSurveys() { return this.vm.estimationsSurveys; }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">List dependencies</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div v-if="initialized" class="alert alert-warning text-dark" role="alert">
                            <p>The list '<strong>{{name}}</strong>' is used in <strong>{{dependenciesCount}}</strong> places.</p>
                        </div>
                        <AlternativesViewDependenciesList :initialized="initialized" 
                                                          :reports="reports"
                                                          :lists="lists"
                                                          :estimationsSurveys="estimationsSurveys" />
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>